import { TakePicture } from './TakePicture';

export default TakePicture;
